import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "HiddenClientCountTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showHidden: { type: Boolean }
  },
  setup(__props: any) {


let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, _toDisplayString(_unref(__)('Скрытые посетители')), 1),
    _createElementVNode("div", null, [
      (__props.showHidden)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_unref(__)('Кликните, чтобы не отображать скрытых пользователей')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_unref(__)('Кликните, чтобы отобразить скрытых пользователей')), 1)
          ], 64))
    ])
  ], 64))
}
}

})